export class GetAppStreamImagesResponse {
    names?: string[];
}